export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";

export const searchType = [
  { label: "Document ID", value: "documentNumber" },
  { label: "Invoice No.", value: "invoiceNumber" },
  { label: "Invoice Amount", value: "invoiceAmount" },
  { label: "Vendor Name", value: "vendorName" },
];
